<template>
<!-- offcanvas -->
<div class="offcanvas offcanvas-start custom-sidebar" style="width: 270px;" tabindex="-1" id="sidebar" aria-labelledby="sidebar">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ul class="navbar-nav">
          <li style="text-align: center;">
            <!-- img src="img/users/user.png" class="rounded-circle mb-2" alt="..." style="width: 27%;" --> 
            <img src="img/users/logo.jpg" class="rounded-circle mb-2" alt="..." style="width: 27%;"> 
            <p>{{ userl }}</p>
          </li>
          <!-- li class="mt-2 mb-2"><hr class="dropdown-divider bg-light" /></li>
          <li>
            <router-link class="sidebar-link" :to="{ name : 'mispedidospendientes' }"><i class="bi bi-cloud-fill me-2"></i> Archivos Guardados</router-link>   
          </li -->
          <li>
            <router-link class="sidebar-link" :to="{ name : 'mispedidosguardados' }"><i class="bi bi-hdd-fill me-2"></i> Archivos Guardados</router-link>   
          </li>
          <li class="mt-2 mb-2"><hr class="dropdown-divider bg-light" /></li>
          <li>
            <router-link class="sidebar-link" :to="{ name : 'mispedidos' }"><i class="bi bi-send-fill me-2"></i> Pedidos Enviados</router-link>   
          </li>
          <li class="mt-2 mb-2"><hr class="dropdown-divider bg-light" /></li>
          <li>
            <router-link class="sidebar-link" :to="{ name : 'miscuentasporcobrar' }"><i class="bi bi-calculator-fill me-2"></i> Cuentas por Cobrar</router-link>   
          </li>         
          <li class="mt-2 mb-2"><hr class="dropdown-divider bg-light" /></li>
          <li>
            <a href="#" @click="irahome" class="sidebar-link"><i class="bi bi-cloud-arrow-down-fill me-2"></i> Sincronizar</a>   
          </li>
          <li class="mt-2 mb-2"><hr class="dropdown-divider bg-light" /></li>
          <li   v-if="loged">
              <a href="#" class="sidebar-link text-danger" @click="logOut" ><i class="bi bi-x-square-fill me-2"></i> Cerrar Sesion</a> 
          </li>
        </ul>
        <hr>
  </div>
</div>
</template>

<script setup>
  import { defineProps } from 'vue'
  import { useRouter } from 'vue-router'

  defineProps({
    loged : Boolean,
    userl : String
  })

  const router = useRouter()

  const irahome = ( async ()=>{
    localStorage.removeItem('last_sync_time')
    await router.push('/')
    location.reload()
  })

  const logOut = ( async ()=>{
    localStorage.removeItem('spx_localdata')
    localStorage.removeItem('spx_params')
    localStorage.removeItem('spx_mydata')
    localStorage.removeItem('spx_lastdoc')
    localStorage.removeItem('spx_clientlist')
    localStorage.removeItem('spx_priceslist')
    localStorage.removeItem('spx_marylist')
    localStorage.removeItem('spx_comentario')
    localStorage.removeItem('spx_lastreq')
    localStorage.removeItem('spx_orderslist')
    localStorage.removeItem('last_sync_time')
    localStorage.removeItem('spx_canales')
    location.reload()
  })

</script>

<style scoped>
  .custom-sidebar {
    background: linear-gradient(135deg, #e3eafc 60%, #f5f5f5 100%);
    box-shadow: 2px 0 12px rgba(0,0,0,0.07);
  }
  .sidebar-link {
    display: flex;
    align-items: center;
    padding: 0.6em 0.5em;
    border-radius: 0.5em;
    text-decoration: none;
    color: #222;
    font-weight: 500;
    transition: background 0.2s;
  }
  .sidebar-link:hover {
    background: #e3eafc;
    color: #0d6efd;
  }
</style>
